import {
  Box,
  Button,
  Container,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import * as React from "react";
import { styled } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import { createCategory, updateCategory } from "../../actions/category";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { deleteCategory } from "../../actions/category";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet-async";
import API from "../../Api/api";
import { Modal } from "antd";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#75CA93 ",
    color: theme.palette.common.black,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(id, category) {
  return { id, category };
}

export default function Category() {
  const [editingId, setEditingId] = React.useState(null);
  const [deletingId, setDeletingId] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const showModal = () => {
    setOpenModal(true);
  };
  const handleOk = () => {
    setOpenModal(false);
  };
  const handleCancel = () => {
    setOpenModal(false);
    setDeletingId(null);
  };
  const [idx, setIdx] = React.useState(null);
  const [categoryName, setCategoryName] = React.useState("");
  const [category, setCategory] = React.useState("");
  const carts = useSelector((state) => state.category.cart);
  const [data, setData] = React.useState(carts);

  React.useEffect(() => {
    setData(carts);
  }, [carts]);
  const rows = data.map((data) => createData(data._id, data.category));
  function editData(id) {
    setEditingId(id);
  }
  const dispatch = useDispatch();
  async function sendData() {
    if (!category) {
      toast.error("Please enter category name");
      return;
    }
    //  if category then we will dispatch the data
    dispatch(createCategory({ category }));
    setCategory("");
  }

  const updateArray = (arr) => {
    return Promise.all(arr.map((item) => updateItem(item)));
  };

  const updateItem = async (item) => {
    try {
      // Simulate a fetch request to update the item (replace this with your actual API call)
      await API.patch(`api/v1/eClaim/${item._id}`, {
        category: data[idx].category,
      });
    } catch (error) {
      toast.error(error.message);
    }
  };
  async function handleSaveData(id, index) {
    try {
      if (!editingId) {
        toast.error("Please you have not made any changes");
        return;
      }
      const allClaimsData = await API.get(
        `api/v1/eClaim?category[eq]=${categoryName}`
      );
      dispatch(updateCategory(id, data[index]));
      // Update all objects in the array
      if (allClaimsData.data.length > 0) {
        updateArray(allClaimsData.data)
          .then((updatedArray) => {
            toast.success("all transactions with the same category updated");
          })
          .catch((err) => {
            toast.error("Error updating items please try again:");
          });
      }
      setEditingId(null);
    } catch (error) {}
  }
  return (
    <div
      style={{
        display: "absolute",
        top: 50,
        marginTop: "80px",
      }}>
      <Modal
        maskClosable={false}
        closable={false}
        open={openModal}
        title='Deleting Confirmation'
        onOk={handleOk}
        onCancel={handleCancel}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <Button
              onClick={() => {
                dispatch(deleteCategory(deletingId));
                handleCancel();
              }}>
              Yes
            </Button>
            <Button
              style={{ color: "red" }}
              onClick={() => {
                handleCancel();
              }}>
              No
            </Button>
          </>
        )}>
        <p>Do you want to proceed with deleting this category?</p>
      </Modal>
      <Helmet title='Categories - eClaim' />
      <Container
        style={{
          display: "absolute",
          top: 50,
          marginTop: "100px",
          paddingBottom: "30px",
        }}>
        <TextField
          style={{
            color: "#fff",
            border: "1px solid #000",
            marginRight: "20px",
            borderRadius: "10px",
            backgroundColor: "#fff",
          }}
          size='small'
          type='text'
          placeholder='category name'
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
        <Button
          onClick={sendData}
          style={{ backgroundColor: "#75CA93 ", color: "#000" }}
          variant='contained'>
          Add
        </Button>
        <Box marginTop={1}>
          <TableContainer component={Paper}>
            <Table
              size='small'
              sx={{ minWidth: 700 }}
              aria-label='customized table'>
              <TableHead style={{ backgroundColor: "#75CA93 " }}>
                <TableRow style={{ backgroundColor: "#75CA93 " }}>
                  {/* <StyledTableCell>ID</StyledTableCell> */}
                  <StyledTableCell align='left'>CATEGORY</StyledTableCell>
                  <StyledTableCell align='right'>ACTION</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell align='left'>
                      {editingId === row.id ? (
                        <TextField
                          type='text'
                          value={row.category}
                          onChange={(e) =>
                            setData((prevData) =>
                              prevData.map((item) =>
                                item._id === row.id
                                  ? { ...item, category: e.target.value }
                                  : item
                              )
                            )
                          }
                          size='small'
                        />
                      ) : (
                        row.category
                      )}
                    </StyledTableCell>

                    <StyledTableCell style={{}} align='right'>
                      <Tooltip title='delete'>
                        <IconButton
                          size='small'
                          onClick={() => {
                            setDeletingId(row.id);
                            showModal();
                          }}>
                          <DeleteOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title='Edit'>
                        <IconButton
                          size='small'
                          onClick={() => {
                            editData(row.id);
                            setCategoryName(row.category);
                            setIdx(index);
                          }}>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      {editingId === row.id && (
                        <Tooltip title='save changes'>
                          <IconButton
                            onClick={() => handleSaveData(row.id, index)}
                            size='small'>
                            <SaveIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      {editingId === row.id && (
                        <Tooltip title='cancel'>
                          <IconButton
                            size='small'
                            onClick={() => setEditingId(null)}>
                            <CancelIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Container>
    </div>
  );
}
